module.exports = __webpack_public_path__ + "img/menu (2).fff4bcb8.jpg";